import _                                     from 'underscore';
import React, { FC }                         from 'react';
import { List }                              from 'semantic-ui-react';
import moment, { DurationInputArg2, Moment } from 'moment';

import { DecisionEngineQueries }                       from '../../../../../queries';
import { CorvalActivitySubObjective, T_OR_NULL, Uuid } from '../../../../../types';
import { TimeService }                                 from '../../../../../services/TimeService';
import { ItemFromQuery }                               from '../../../../components/from-query/ItemFromQuery';
import { TIME_UNITS }                                  from '../../../../../constants/TimeEnums';
import { HumanizedDateRangeLabel }                     from '../../../../components/labels/HumanizedDateRangeLabel';

interface Props {
	id: Uuid
}

const defaultProps: Props = {
	id: null
}

const ObjectiveDetailEstimatedTiming: FC<Props> = ( props ) => {
	
	return (
		
		<ItemFromQuery
			as={ List.Item }
			query={ DecisionEngineQueries.queries.GET_SUBOBJECTIVE( `id activities{ activity{ id defaultTimeSpanValue defaultTimeSpanUnit } }` ) }
			queryOptions={ {
				variables: {
					id: props.id
				}
			} }
			queryResultObject={ ( data ) => {
				
				if( data.subObjective.activities.length ){
					
					let subObjectiveActivities = data.subObjective.activities as CorvalActivitySubObjective[];
					
					let dateObjects = _.map( subObjectiveActivities, ( a ) => {
						
						let duration        = a.activity.defaultTimeSpanValue as number,
						    timeUnit        = a.activity.defaultTimeSpanUnit,
						    momentTimeUnits = {
							    [ TIME_UNITS.DAYS ]:   'days',
							    [ TIME_UNITS.WEEKS ]:  'weeks',
							    [ TIME_UNITS.MONTHS ]: 'months',
							    [ TIME_UNITS.YEARS ]:  'years',
						    };
						
						return {
							startTime: moment(),
							endTime:   moment().add( duration, momentTimeUnits[ timeUnit ] as DurationInputArg2 ),
						}
					} );
					
					return TimeService.getStartEndLimitorDates( dateObjects );
				}
				
				return [ null, null ];
			} }>
			
			{ ( [ startDate, endDate ]: T_OR_NULL<Moment>[] ) => {
				
				return <HumanizedDateRangeLabel startDate={ startDate } endDate={ endDate } relativeLanguage={ true }/>
			} }
		
		</ItemFromQuery>
	);
};

ObjectiveDetailEstimatedTiming.defaultProps = defaultProps;

export { ObjectiveDetailEstimatedTiming }
